import React from "react";
import { CreateSupportTicket } from "../../../services/supportTicket";
import SupportTicketForm from "../../../forms/SupportTickets";
import {
  GeneratePresignedUrl,
  UploadFile,
} from "../../../services/media/index";
const CreateSupportTicketForm = ({ fetchTickets }) => {
  //   const [boxes, setBoxes] = useState([]);

  const handleSubmit = async (payload) => {
    try {
      const { data } = await CreateSupportTicket(payload);

      fetchTickets();
      return data;
    } catch (e) {
      return e.response.data;
    }
  };

  const handleFileUpload = async (file) => {
    if (file) {
      const { data } = await GeneratePresignedUrl({
        fileName: file.name,
        fileType: file.type,
      });
      if (data.result) {
        const { presignedUrl, downloadUrl } = data.result;

        const res = await UploadFile({ file, url: presignedUrl });
        if (res.status === 200) {
          return downloadUrl;
        } else {
          throw new Error("Could not upload the file.");
        }
      }
    }
  };

  return (
    <>
      <SupportTicketForm
        onSubmit={handleSubmit}
        editable={true}
        key={"support-form"}
        handleFileUpload={handleFileUpload}
      />
    </>
  );
};

export default CreateSupportTicketForm;
